import { PostPosterCard } from "@/entities/post"
import { type ContinueWatchingItem, useContinueWatching } from "@/entities/view-history"
import { Rail, RailItem } from "@/shared/ui/rail"
import { Skeleton } from "@/shared/ui/skeleton"

const CARD_WIDTH = "w-[calc((min(100vw,48rem)-1.5rem)/1.6-0.75rem)]"

function remainingLabel({
	videoProgress,
	videoDuration,
}: ContinueWatchingItem): string | undefined {
	if (!videoDuration || videoProgress == null) return undefined
	const minutes = Math.ceil((videoDuration - videoProgress) / 60)
	return minutes > 0 ? `Осталось ${minutes} мин` : undefined
}

export function ContinueWatching() {
	const { data: items = [], isLoading } = useContinueWatching(10)

	if (isLoading) return <ContinueWatchingSkeleton />
	if (items.length === 0) return null

	return (
		<Rail title="Продолжить просмотр" tourKey="continue">
			{items.map((item) => (
				<RailItem key={item.id}>
					<PostPosterCard
						className={CARD_WIDTH}
						post={item.post}
						progress={
							item.videoDuration && item.videoProgress != null
								? item.videoProgress / item.videoDuration
								: null
						}
						meta={remainingLabel(item)}
					/>
				</RailItem>
			))}
		</Rail>
	)
}

function ContinueWatchingSkeleton() {
	return (
		<Rail title="Продолжить просмотр" tourKey="continue">
			{Array.from({ length: 2 }).map((_, index) => (
				<RailItem key={index} className={CARD_WIDTH}>
					<Skeleton className="aspect-video w-full rounded-xl" />
					<Skeleton className="mt-2 h-4 w-11/12" />
					<Skeleton className="mt-1.5 h-3 w-1/2" />
				</RailItem>
			))}
		</Rail>
	)
}
